import { Comparer } from './Comparer';
export class InputComparer extends Comparer {
    constructor(wording) {
        super(wording);
    }
    get wordTask() {
        return this.wording.wordTask;
    }
    get userInput() {
        return this.wordTask.wordTaskInput.inputCleaner.cleanedString;
    }
}
